module.exports = "/_next/static/images/ny-1-9f0df018700a08a1a9c9689e2017644f.jpg";